
import { useEffect, useState, createContext } from 'react';
interface Theme {
    NavBackgroundColor: string,
    mainPageBackgroundColor: string,
}
interface IThemeContext{
    actualTheme:Theme,
    setLgTheme:Function
}
const lightTheme: Theme = {
    NavBackgroundColor: "#1D5C63",
    mainPageBackgroundColor: "#EDE6DB"
}
const darkTheme: Theme = {
    NavBackgroundColor: "#1A3C40",
    mainPageBackgroundColor: "#1A3C40"
}
const initialValue: IThemeContext = {
    actualTheme: lightTheme,
    setLgTheme:()=>{}
}
export const ThemeContext = createContext<IThemeContext>(initialValue);
const ThemeContextProvider = ({ children }: any): JSX.Element => {
    const [lgTheme, setLgTheme] = useState(true);
    const [actualTheme, setActualTheme] = useState<Theme>(lightTheme);
    useEffect(() => {
        const handleChange = () => {
            if (lgTheme) {
                return setActualTheme(lightTheme);
            }
            return setActualTheme(darkTheme)
        }
        handleChange();
    }, [lgTheme])
    return (
        <ThemeContext.Provider value={{ setLgTheme, actualTheme }} >
            {children}
        </ThemeContext.Provider>
    );
}

export default ThemeContextProvider